import type { AxiosPromise, AxiosRequestConfig } from 'axios';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { api } from '@/api';

export async function getCatalogDrivers(
  params: openapi.GetCatalogDrivers_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetCatalogDrivers_200> {
  return await api.get<openapi.GetCatalogDrivers_200>('/catalog/drivers/', {
    ...requestConfig,
    params,
  });
}

export async function getCatalogOffsiders(
  params: openapi.GetCatalogOffsiders_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetCatalogOffsiders_200> {
  return await api.get<openapi.GetCatalogOffsiders_200>('/catalog/offsiders/', {
    ...requestConfig,
    params,
  });
}

export async function getCatalogServiceCodes(
  params: openapi.GetCatalogServiceCodes_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetCatalogServiceCodes_200> {
  return await api.get<openapi.GetCatalogServiceCodes_200>(
    '/catalog/service-codes/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getCatalogAttributes(
  params: openapi.GetCatalogAttributes_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetCatalogAttributes_200> {
  return await api.get<openapi.GetCatalogAttributes_200>(
    '/catalog/attributes/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getCatalogGoodsTypes(
  params: openapi.GetCatalogGoodsTypes_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetCatalogGoodsTypes_200> {
  return await api.get<openapi.GetCatalogGoodsTypes_200>(
    '/catalog/goods-types/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getCatalogSites(
  params: openapi.GetCatalogSites_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetCatalogSites_200> {
  return await api.get<openapi.GetCatalogSites_200>('/catalog/sites/', {
    ...requestConfig,
    params,
  });
}

export async function getCatalogServiceGroups(
  params: openapi.GetCatalogServiceGroups_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetCatalogServiceGroups_200> {
  return await api.get<openapi.GetCatalogServiceGroups_200>(
    '/catalog/service-groups/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getCatalogTechnicians(
  params: openapi.GetCatalogTechnicians_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetCatalogTechnicians_200> {
  return await api.get<openapi.GetCatalogTechnicians_200>(
    '/catalog/technicians/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function postCatalogTechnicians(
  params: openapi.PostCatalogTechnicians_Query,
  data: openapi.PostCatalogTechnicians_Body,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.PostCatalogTechnicians_201> {
  return await api.post<openapi.PostCatalogTechnicians_201>(
    '/catalog/technicians/',
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function putCatalogTechniciansByid(
  params: openapi.PutCatalogTechniciansById_Query,
  path: openapi.PutCatalogTechniciansById_Path,
  data: openapi.PutCatalogTechniciansById_Body,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.PutCatalogTechniciansById_200> {
  return await api.put<openapi.PutCatalogTechniciansById_200>(
    `/catalog/technicians/${path.id}/`,
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function patchCatalogTechniciansByid(
  params: openapi.PatchCatalogTechniciansById_Query,
  path: openapi.PatchCatalogTechniciansById_Path,
  data: openapi.PatchCatalogTechniciansById_Body,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.PatchCatalogTechniciansById_200> {
  return await api.patch<openapi.PatchCatalogTechniciansById_200>(
    `/catalog/technicians/${path.id}/`,
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getCatalogBases(
  params: openapi.GetCatalogBases_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetCatalogBases_200> {
  return await api.get<openapi.GetCatalogBases_200>('/catalog/bases/', {
    ...requestConfig,
    params,
  });
}

export async function getCatalogZones(
  params: openapi.GetCatalogZones_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetCatalogZones_200> {
  return await api.get<openapi.GetCatalogZones_200>('/catalog/zones/', {
    ...requestConfig,
    params,
  });
}

export async function getCatalogServiceAreas(
  params: openapi.GetCatalogServiceAreas_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetCatalogServiceAreas_200> {
  return await api.get<openapi.GetCatalogServiceAreas_200>(
    '/catalog/service-areas/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getCatalogFleets(
  params: openapi.GetCatalogFleets_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetCatalogFleets_200> {
  return await api.get<openapi.GetCatalogFleets_200>('/catalog/fleets/', {
    ...requestConfig,
    params,
  });
}

export async function getCatalogDriverTypes(
  params: openapi.GetCatalogDriverTypes_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetCatalogDriverTypes_200> {
  return await api.get<openapi.GetCatalogDriverTypes_200>(
    '/catalog/driver-types/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getCatalogAll(
  params: openapi.GetCatalogAll_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetCatalogAll_200> {
  return await api.get<openapi.GetCatalogAll_200>('/catalog/all/', {
    ...requestConfig,
    params,
  });
}
